import { useMutation, useQueryClient } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { useSnackbar } from "src/utils/useSnackbar";
import { getAllActionPlanKey } from "./useGetAllActionPlan";
import { getOneActionPlanKey } from "./useGetOneActionPlan";

export const useRecalculateActionPlan = (actionPlanID: string | undefined) => {
    const snackbar = useSnackbar();
    const queryClient = useQueryClient();

    const query = useMutation({
        mutationFn: async (options: unknown) => {
            if (actionPlanID === undefined) {
                snackbar.forceClose();
                snackbar.setSnackbarProps({
                    type: "error",
                    message: "Missing an ActionPlanID. Please, contact your admin.",
                });
                return;
            }

            snackbar.forceClose();
            snackbar.setSnackbarProps({
                type: "info",
                message: "Recalculating... please, wait",
                forceAutoHideInMilisecond: null,
            });

            queryClient.refetchQueries([getAllActionPlanKey]);

            const url = `/api/action_plans/${actionPlanID}/recalculate-simulation`;
            const req = loggedInApiCall.post(
                url,
                {},
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                },
            );
            return req;
        },
        onSuccess: () => {
            snackbar.forceClose();
            snackbar.setSnackbarProps({
                type: "success",
                message: "Recalculation done !",
            });

            queryClient.refetchQueries([getOneActionPlanKey]);
        },
        onError: () => {
            snackbar.forceClose();
            snackbar.setSnackbarProps({
                type: "error",
                message: "Recalculation failed, retry ?",
            });

            queryClient.refetchQueries([getOneActionPlanKey]);
        },
    });

    return query;
};
